import { publicApi } from '@netiva/classifieds-api';
import { useMemo } from 'react';

export const usePlatforms = () => {
  const { data: platformsData, isLoading } = publicApi.useGetConfigurationPlatforms({});
  const platforms = useMemo(
    () =>
      platformsData?.items.filter(
        // exclude print platforms
        (p) => !p.dataObjectTypes.some((t) => t.type === 'EInserat' || t.type === 'ChMediaPdf')
      ) || [],
    [platformsData]
  );
  return { platforms, isLoading };
};
